<template>
  <main class="profile">
    <LightsImage />

    <SummarySection />

    <GameSection />

    <template v-if="isUserAchievementVisible">
      <AchievementsSection />

      <LevelsSection />
    </template>

    <StatisticsSection />

    <template v-if="hasInviteFunctionality">
      <BaseInviteItem @invite="openInviteModal" />

      <InviteModal v-if="isInviteModalOpen" @invite:resolved="closeInviteModal" />
    </template>
  </main>
</template>

<script setup>
import { onMounted } from 'vue';
import LightsImage from '@/components/image/LightsImage.vue';
import InviteModal from '@/components/modal/InviteModal.vue';
import BaseInviteItem from '@/components/item/BaseInviteItem.vue';
import SummarySection from '@/views/profileOverview/components/section/SummarySection.vue';
import GameSection from '@/views/profileOverview/components/section/GameSection.vue';
import AchievementsSection
  from '@/views/profileOverview/components/section/AchievementsSection.vue';
import LevelsSection from '@/views/profileOverview/components/section/LevelsSection.vue';
import StatisticsSection from '@/views/profileOverview/components/section/StatisticsSection.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';
import useModalHook from '@/hooks/useModal.js';

const appSettingsStore = useAppSettingsStore();
const authStore = useAuthStore();

const hasInviteFunctionality = appSettingsStore.appProperties.inviteConfig.inviteEnabled;
const isUserAchievementVisible = !appSettingsStore.appProperties.hideUserAchievements;

const [isInviteModalOpen, openInviteModal, closeInviteModal] = useModalHook();

onMounted(async () => {
  const promiseActionList = [
    authStore.dispatchRetrieveUserStatistics,
  ];

  if (isUserAchievementVisible) {
    promiseActionList.push(authStore.dispatchRetrieveUserAchievements);
  }

  await Promise.allSettled(promiseActionList.map(action => action()));
});
</script>
